import { PartnerReferral } from "./partner-referral";

export type PartnerReferralAction =
  | PartnerReferralGetAction
  | PartnerReferralGetSuccessAction
  | PartnerReferralGetFailAction
  | PartnerReferralClearErrorAction;

export const PartnerReferralGetActionType = "partner-referral/get" as const;
export type PartnerReferralGetAction = ReturnType<
  typeof partnerReferralGetAction
>;
export function partnerReferralGetAction(wisrCustomerId: string) {
  return {
    type: PartnerReferralGetActionType,
    wisrCustomerId: wisrCustomerId,
  };
}

export const PartnerReferralGetSuccessActionType =
  "partner-referral/get-success" as const;
export type PartnerReferralGetSuccessAction = ReturnType<
  typeof partnerReferralGetSuccessAction
>;
export function partnerReferralGetSuccessAction(
  partnerReferral: PartnerReferral
) {
  return {
    type: PartnerReferralGetSuccessActionType,
    partnerReferral,
  };
}

export const PartnerReferralGetFailActionType =
  "partner-referral/get-fail" as const;
export type PartnerReferralGetFailAction = ReturnType<
  typeof partnerReferralGetFailAction
>;
export function partnerReferralGetFailAction(errorMessage: string) {
  return {
    type: PartnerReferralGetFailActionType,
    errorMessage,
  };
}

export const PartnerReferralClearErrorActionType =
  "partner-referral/clear-error" as const;
export type PartnerReferralClearErrorAction = ReturnType<
  typeof partnerReferralClearErrorAction
>;
export function partnerReferralClearErrorAction() {
  return { type: PartnerReferralClearErrorActionType };
}
